import { Typography, TypographyProps } from '@mui/material';
import { styled } from '@mui/material/styles';

import { Montserrat } from 'styles/common-fonts';

export const HeadlineMediumStyled = styled(Typography)<TypographyProps>(() => ({
  fontFamily: Montserrat,
  fontWeight: 700,
  fontSize: '1.75rem',
}));
